<!--
  @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
  @license AGPL-3.0

  This code is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.

  Any use of the work other than as authorized under this license or copyright law is prohibited.
-->

<template>
  <div
    class="toggle"
    role="switch"
    tabindex="0"
    :aria-label="i18n.toggle"
    :aria-checked="isToggled.toString()"
    @click="toggle"
    @keydown.enter.space="toggle"
  >
    <div class="toggle-bg" :class="{ 'dark-mode': isToggled }"></div>
    <div class="toggle-slot light-mode">
      <BaseIcon icon-name="bi/sun.svg" class="bi-16"></BaseIcon>
    </div>
    <div class="toggle-slot dark-mode">
      <BaseIcon icon-name="bi/moon.svg" class="bi-16"></BaseIcon>
    </div>
  </div>
</template>

<script setup>
import BaseIcon from '@/io.ox/vueComponents/base-icon.vue'
import gt from 'gettext'

const props = defineProps({
  isToggled: { type: Boolean, default: false }
})

function toggle () {
  emit('toggle', !props.isToggled)
}

const emit = defineEmits(['toggle'])

const i18n = {
  toggle: gt('Toggle dark mode')
}
</script>

<style lang="scss" scoped>
.toggle {
  width: 64px;
  height: 34px;
  background: var(--background);
  border-radius: var(--default-radius);
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;

  &:focus-visible { outline: 2px solid var(--outline); }

  svg { color: var(--toolbar); }

  .toggle-bg {
    position: absolute;
    width: 30px;
    height: 30px;
    background-color: var(--selected-background);
    border-radius: var(--default-radius);
    transition: left 0.3s ease;
    left: 2px;
    z-index: 1;
  }

  .toggle-bg.dark-mode {
    left: 50%;
  }

  .toggle-slot {
    flex: 1;
    z-index: 2;
    text-align: center;
    font-size: 18px;
    opacity: 0.5;
    transition: opacity 0.2s ease;
  }

  .toggle-slot.light-mode {
    opacity: v-bind('isToggled ? 0.5 : 1');
  }

  .toggle-slot.dark-mode {
    opacity: v-bind('isToggled ? 1 : 0.5');
  }
}
</style>
